import React from 'react'
import View from '../Components/View'

function ViewPage() {
  return (
    <div><View></View></div>
  )
}

export default ViewPage